module.exports = __webpack_public_path__ + "d47dd061d8c2c2762150ad6d2245bf11.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-david.png
// module id = 653
// module chunks = 0